import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDR0xG7sOx1LFtgjjbxtfak41NV8SNPm1U',
  authDomain: 'jyp-admin-saas.firebaseapp.com',
  databaseURL: 'https://jyp-admin-saas.firebaseio.com',
  projectId: 'jyp-admin-saas',
  storageBucket: '',
  messagingSenderId: '813479589334',
};
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
db.settings({
  timestampsInSnapshots: true,
});

export const auth = firebase.auth();



// WEBPACK FOOTER //
// ./src/utils/configureFirebase.js